import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createCustomerInquiry, getMyInquiryDetail, getMyInquiryList } from '../../lib/api/notice-support-api';
import { useAuth } from '../../contexts/AuthContext';
import './CustomerServicePage.css';

function CustomerServicePage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isDetail = !!id;
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isIntakeOpen, setIsIntakeOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    title: '',
    content: '',
  });

  useEffect(() => {
    const load = async () => {
      const requester = user?.userId || 'guest';
      try {
        if (isDetail) {
          const response = await getMyInquiryDetail(id, requester);
          setSelectedItem(response?.data || null);
        } else {
          const response = await getMyInquiryList(requester);
          setItems(response?.data || []);
        }
      } catch (err) {
        setError(err.message || (isDetail ? '문의 상세를 불러오지 못했습니다.' : '내 문의 목록을 불러오지 못했습니다.'));
      } finally {
        setLoading(false);
      }
    };

    setIsIntakeOpen(false);
    load();
  }, [id, isDetail, user?.userId]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await createCustomerInquiry({
        requester: user?.userId || 'guest',
        title: formData.title,
        content: formData.content,
      });

      if (response?.success) {
        alert('문의가 접수되었습니다. 빠르게 확인 후 답변드리겠습니다.');
        setFormData({ title: '', content: '' });
        setIsIntakeOpen(false);
      }
    } catch (err) {
      alert(err.message || '문의 접수에 실패했습니다.');
    }
  };

  return (
    <div className="customer-service-page">
      <div className="cs-content">
        <div className="cs-container">
          <div className="cs-topbar">
            <h1>고객센터</h1>
            {!isDetail && (
              <button type="button" className="cs-open-inquiry-btn" onClick={() => setIsIntakeOpen(true)}>
                문의 접수
              </button>
            )}
          </div>

          {loading && <div className="cs-status">불러오는 중입니다...</div>}
          {!!error && <div className="cs-status error">{error}</div>}

          {!loading && !isDetail && (
            <div className="cs-panels">
              <div className="cs-list">
                <table className="cs-table">
                  <thead>
                    <tr>
                      <th className="col-no">번호</th>
                      <th>제목</th>
                      <th className="col-status">상태</th>
                      <th className="col-date">접수일시</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => (
                      <tr
                        key={item.id}
                        onClick={() => navigate(`/customer-service/${item.id}`)}
                      >
                        <td className="col-no">{items.length - index}</td>
                        <td>{item.title}</td>
                        <td className="col-status">{item.status}</td>
                        <td className="col-date">{item.receivedAt}</td>
                      </tr>
                    ))}
                    {items.length === 0 && (
                      <tr>
                        <td className="cs-empty-row" colSpan={4}>내가 남긴 문의가 없습니다.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          )}

          {!loading && isDetail && selectedItem && (
            <div className="cs-detail single">
              <button type="button" className="detail-back-top" onClick={() => navigate('/customer-service')}>
                돌아가기
              </button>
              <h2>{selectedItem.title}</h2>
              <div className="cs-meta">
                <span>상태: {selectedItem.status}</span>
                <span>접수일시: {selectedItem.receivedAt}</span>
                {selectedItem.answeredAt && <span>답변일시: {selectedItem.answeredAt}</span>}
              </div>
              <div className="cs-detail-body">{selectedItem.content}</div>
              {selectedItem.answerContent && (
                <div className="cs-answer-box">
                  <h4>관리자 답변</h4>
                  <p>{selectedItem.answerContent}</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {isIntakeOpen && (
        <div className="cs-popup-overlay" role="dialog" aria-modal="true" aria-label="고객센터 접수">
          <div className="cs-popup">
            <div className="cs-popup-header">
              <h3>1:1 문의 접수</h3>
              <button type="button" onClick={() => setIsIntakeOpen(false)}>닫기</button>
            </div>

            <form className="qna-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="title">제목 *</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="문의 제목"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="content">내용 *</label>
                <textarea
                  id="content"
                  name="content"
                  value={formData.content}
                  onChange={handleChange}
                  rows="7"
                  placeholder="문의 내용을 입력해 주세요"
                  required
                />
              </div>

              <button type="submit" className="submit-button">
                접수하기
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomerServicePage;
